import { React, useEffect, useState }  from "react";
import "./AddToShelf.css";
import axios from 'axios';

import { API_BASE_URL } from "../../Variables";
import { isShelfMain } from "../../services/Utils";

function AddToShelf( {bookId, onClose, book, refreshShelves} ) {
  const [error, setError] = useState(null);
  const [shelves, setShelves] = useState([]);
  const [shelvesWithBook, setShelvesWithBook] = useState([]);
  const [selectedMainShelf, setSelectedMainShelf] = useState(null);
  const [selectedCustomShelves, setSelectedCustomShelves] = useState([]);
  const [mainShelves, setMainShelves] = useState([]);
  const [customShelves, setCustomShelves] = useState([]);

  const token = localStorage.getItem('token');

  /**
   * Handles selecting a shelf
   * @param {*} shelfId - id of shelf to select
   * @param {*} type - type of shelf (main or custom)
   */
  const handleShelfSelection = (shelfId, type) => {
    // If main shelf, only one can be selected at a time
    if (type === 'main') {
      setSelectedMainShelf(prevShelf => prevShelf === shelfId ? null : shelfId);
    } else {
      // If custom shelf, multiple can be selected
      setSelectedCustomShelves((prev) =>
        prev.includes(shelfId)
          ? prev.filter((id) => id !== shelfId)
          : [...prev, shelfId]
      );
    }
  };

  /**
   * Saves selected shelves, updates book in shelves
   */
  const handleSave = async () => {
    try {
      const shelvesToUpdate = [...selectedCustomShelves];
      if (selectedMainShelf) shelvesToUpdate.push(selectedMainShelf);
  
      await axios.post(`${API_BASE_URL}/books-in-shelf`, {
        book,
        book_id: bookId,
        shelf_ids: shelvesToUpdate,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if(refreshShelves){
        refreshShelves();
      }
  
      onClose(false); 
    } catch (error) {
      setError('Failed to save shelves');
    }
  };

  /**
   * Fetch shelves and shelves that include the book
   */
  useEffect(() => {
    const fetchShelves = async () => {
      try {
        const responseAllShelves = await axios.get(`${API_BASE_URL}/shelves`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
        });

        const responseShelvesWithBook = await axios.get(`${API_BASE_URL}/shelves/book/${bookId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setShelves(responseAllShelves.data);
        setShelvesWithBook(responseShelvesWithBook.data);
      } catch (error) {
        setError('Failed to load shelves');
      }
    };

    fetchShelves();

  }, [bookId, token]);

  /**
   * Update main and custom shelves based on fetched shelves
   * Update selected main and custom shelves based on shelves that include the book
   */
  useEffect(() => {
    setMainShelves(shelves.filter(shelf => isShelfMain({ shelfName: shelf.name })));
    setSelectedMainShelf(shelvesWithBook.find(shelf => isShelfMain({ shelfName: shelf.name }))?.id || null);
    
    setCustomShelves(shelves.filter(shelf => !isShelfMain({ shelfName: shelf.name })));
    setSelectedCustomShelves(shelvesWithBook.filter(shelf => !isShelfMain({ shelfName: shelf.name })).map(shelf => shelf.id));
  }, [shelves, shelvesWithBook]);

  return (
    <div className="modal-overlay">
      <div className="add-to-shelf">
        <h3 className="add-to-shelf-header">Add to Shelf</h3>
        {error && <p className="error">{error}</p>}

        {/* Main Shelves */}
        <div className="main-shelves">
          {mainShelves.map((shelf) => (
            <div key={shelf.id} className="selectable-item" onClick={() => handleShelfSelection(shelf.id, "main")}>
              <div className={selectedMainShelf === shelf.id ? "selected-circle" : "circle"}/>
              <span className="shelf-name">{shelf.name}</span>
            </div>
          ))}
        </div>

        <hr className="divider" />

        {/* Custom Shelves */}
        <div className="custom-shelves">
          {customShelves.map((shelf) => (
            <label key={shelf.id} className="shelf-option">
              <input
                type="checkbox"
                checked={selectedCustomShelves.includes(shelf.id)}
                onChange={() => handleShelfSelection(shelf.id, 'custom')}
              />
              <span className="shelf-name">{shelf.name}</span>
            </label>
          ))}
        </div>
  
        {/* Save and Done buttons */}
        <div className="add-to-shelf-buttons">
          <button onClick={handleSave} className="tertiary-button">Save</button>
          <button onClick={() => onClose(false)} className="secondary-button">Done</button>
        </div>

      </div>
    </div>
  );
}

export default AddToShelf;
